import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';

const SankrantiCelebrationsJan2026 = () => {
    const celebrationImages = [
        "IMG-20260109-WA0018.jpg",
        "IMG-20260109-WA0009.jpg",
        "IMG-20260109-WA0015.jpg",
        "IMG-20260109-WA0014.jpg",
        "IMG-20260109-WA0017.jpg",
        "IMG-20260109-WA0019.jpg",
        "IMG-20260109-WA0020.jpg",
        "01_09_2026_01_23_00_pm.jpg",
        "IMG-20260109-WA0011.jpg",
        "01_09_2026_01_23_07_pm.jpg",
        "01_09_2026_01_23_38_pm.jpg",
        "01_09_2026_10_43_01_am.jpg",
        "IMG-20260111-WA0001.jpg",
        "IMG-20260107-WA0002.jpg",
    ];

    return (
        <div>
            <Navbar />

            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">
                                    <h2>
                                        Sankranti Celebrations at SWEC
                                    </h2>

                                    <div className="py-2">
                                        <p>
                                            The Sankranti celebrations at SWEC were marked by vibrant creativity
                                            and traditional fervor. Students showcased their artistic talents
                                            through intricate Rangoli designs, complemented by colorful
                                            traditional attire.
                                        </p>

                                        <p>
                                            A highlight of the festivities was a special lunch hosted by the MBA
                                            first-year students, who served a sumptuous spread of traditional
                                            delicacies on classic banana leaves for both faculty and peers.
                                        </p>
                                    </div>

                                    <div className="css-script-ads"></div>

                                    <div className="spotlight-group">
                                        <div className="row">
                                            {celebrationImages.map((img, index) => (
                                                <div key={index} className="col-md-6 mb-3 mb-lg-4">
                                                    <a
                                                        className="spotlight"
                                                        href={`https://admin.swec.ac.in/assetsswec/img/Sankranti-Celebrations-Jan-2026/${img}`}
                                                    >
                                                        <img
                                                            src={`https://admin.swec.ac.in/assetsswec/img/Sankranti-Celebrations-Jan-2026/${img}`}
                                                            alt={`Sankranti Celebrations at SWEC Image ${index + 1}`}
                                                            className="img-responsive center-block"
                                                        />
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default SankrantiCelebrationsJan2026;
